export const DropletsCascade = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="32"
    viewBox="0 0 40 32"
    fill="none"
  >
    <path
      opacity="0.5"
      d="M22.6668 4.02637C23.3335 7.3597 25.3335 10.5597 28.0001 12.693C30.6668 14.8264 32.0001 17.3597 32.0001 20.0264C32.0078 21.8694 31.468 23.6732 30.4492 25.2092C29.4304 26.7451 27.9786 27.9439 26.2777 28.6537"
      stroke="#494949"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.25"
      d="M29.0668 4.02637C29.7334 7.3597 31.7334 10.5597 34.4001 12.693C37.0668 14.8264 38.4001 17.3597 38.4001 20.0264C38.4077 21.8694 37.8679 23.6732 36.8492 25.2092C35.8304 26.7451 34.3785 27.9439 32.6776 28.6537"
      stroke="#494949"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.3468 8.7997C15.2638 7.33453 15.9138 5.71843 16.2668 4.02637C16.9334 7.3597 18.9334 10.5597 21.6001 12.693C24.2668 14.8264 25.6001 17.3597 25.6001 20.0264C25.6077 21.8694 25.0679 23.6732 24.0492 25.2092C23.0304 26.7451 21.5785 27.9439 19.8776 28.6537C18.1767 29.3635 16.3033 29.5522 14.495 29.1961C12.6867 28.8399 11.0248 27.9548 9.72009 26.653M6.93331 21.7331C9.86664 21.7331 12.2666 19.2931 12.2666 16.3331C12.2666 14.7864 11.5066 13.3197 9.98664 12.0797C8.46664 10.8397 7.31998 8.99974 6.93331 7.06641C6.54664 8.99974 5.41331 10.8531 3.87998 12.0797C2.34664 13.3064 1.59998 14.7997 1.59998 16.3331C1.59998 19.2931 3.99998 21.7331 6.93331 21.7331Z"
      stroke="#494949"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
